export const colors = {
  ink: "#06185f",
  muted: "#4c5d86",
  line: "#d9e3f4",
  softLine: "#edf1f7",
  blue: "#0059f6",
  green: "#16a163",
  coral: "#ef6351",
  amber: "#f2a51a",
  teal: "#0f9f9a",
  panel: "rgba(255,255,255,0.92)",
};

export const sections = ["General", "Ventas", "Clientes", "Vendedores", "Vehículos", "Embudo"];

export const pipelineColors = {
  ACTIVO: colors.blue,
  VENTA: colors.green,
  BAJA: colors.coral,
  FUTURO: colors.amber,
};

export const kpiLabels = {
  clientes_nuevos: "Clientes nuevos",
  clientes_futuro: "Clientes futuro",
  clientes_convertidos: "Convertidos",
  clientes_baja: "Clientes baja",
  consultas_nuevas: "Consultas nuevas",
  consultas_promedio_por_cliente: "Consultas promedio",
  leads_sin_asignar: "Sin asignar",
  consultas_activas: "Activas",
  ventas_cerradas: "Ventas",
  bajas: "Bajas",
  futuros: "Futuros",
  conversion_pct: "Conversión",
  monto_vendido: "Monto vendido",
  ticket_promedio: "Ticket promedio",
  tiempo_promedio_cierre_dias: "Tiempo cierre Promedio",
  mejor_vendedor: "Mejor vendedor",
  vendedores_activos: "Vendedores activos",
  leads_asignados: "Leads asignados",
  leads_activos: "Leads activos",
  ventas_financiadas: "Financiadas",
  ventas_contado: "Contado",
  ventas_con_usado: "Con usado",
  consultas_vehiculos: "Consultas",
  modelos_consultados: "Modelos consultados",
  vehiculos_vendidos: "Vendidos",
  modelos_vendidos: "Modelos vendidos",
  modelo_mas_consultado: "Más consultado",
  modelo_mas_vendido: "Más vendido",
  precio_promedio_vendido: "Precio promedio",
  estadio_mas_problematico: "Estadio problemático",
  bajas_estadio_problematico: "Bajas del estadio",
  estancados_estadio_problematico: "Estancados ahí",
  leads_estancados: "Leads estancados",
};

export const kpiStatusStyles = {
  consultas_activas: { label: "Activas", solid: colors.blue, bg: "rgba(0,89,246,0.10)", text: colors.blue },
  ventas_cerradas: { label: "Ventas", solid: colors.green, bg: "rgba(22,161,99,0.12)", text: colors.green },
  clientes_convertidos: { label: "Convertidos", solid: colors.green, bg: "rgba(22,161,99,0.12)", text: colors.green },
  bajas: { label: "Bajas", solid: "#e34d43", bg: "rgba(253,141,130,0.18)", text: "#e34d43" },
  clientes_baja: { label: "Bajas", solid: "#e34d43", bg: "rgba(253,141,130,0.18)", text: "#e34d43" },
  futuros: { label: "Futuros", solid: "#7d8495", bg: "rgba(177,181,194,0.20)", text: "#6b7280" },
  clientes_futuro: { label: "Futuros", solid: "#7d8495", bg: "rgba(177,181,194,0.20)", text: "#6b7280" },
};
